<template>
  <v-container>
    <h1>Company List</h1>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="search"
          label="Search by Unique ID"
          prepend-icon="mdi-magnify"
          @input="fetchCompanyList"
        ></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="order"
          :items="[
            { text: 'Company Create Time', order_by: 'id', value: 'desc', id: 'create_desc' },
            { text: 'Company Name Ascending', order_by: 'name', value: 'asc', id: 'name_asc' },
            { text: 'Company Name Descending', order_by: 'name', value: 'desc', id: 'name_desc' }
          ]"
          label="Sorting"
          item-text="text"
          item-value="id"
          return-object
          @change="fetchCompanyList"
        ></v-select>
      </v-col>
    </v-row>
    <v-data-table
      :headers="filter_headers()"
      :items="companies"
      :items-per-page="perPage"
      :page="page"
      :server-items-length="totalTasks"
      :loading="loading"
      @update:page="updatePage"
    >
      <template v-slot:item.created_at="{ item }">
        {{ formatTime(item.created_at) }}
      </template>
      <template v-slot:item.details="{ item }">
        <v-btn
          color="primary"
          small
          @click="goToCompanyDetails(item.id)"
        >
          Details
        </v-btn>
      </template>
<!--       <template v-slot:item.status="{ item }">
        {{ formatStatus(item.status) }}
      </template>
      <template v-slot:item.process_time="{ item }">
        {{ formatTime(item.process_time) }}
      </template>
      <template v-slot:item.files="{ item }">
        <v-btn
          color="primary"
          small
          :href="`${$http.defaults.baseURL}/api/tasks/${item.id}/originals`"
          target="_blank"
          class="mr-2"
        >
          Original
        </v-btn>
      </template>
      <template v-slot:item.reextract="{ item }">
        <v-btn
          color="primary"
          small
          @click="restartTask(item.id)"
          :disabled="item.status === 'processing'"
        >
          Re-extract
        </v-btn>
      </template>
      <template v-slot:item.review="{ item }">
        <v-btn
          color="primary"
          small
          @click="editTaskData(item.id, item.unique_id)"
          :disabled="['processing', 'extract_failed'].includes(item.status)"
        >
          Review
        </v-btn>
      </template>
      <template v-slot:item.show_result="{ item }">
        <v-btn
          color="primary"
          small
          @click="showResult(item.id, item.unique_id)"
          :disabled="item.status != 'completed'"
        >
          Show Result
        </v-btn>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      companies: [],
      search: '',
      order: { text: 'Create Order', order_by: 'id', value: 'desc', id: 'create_desc' },
      page: 1,
      perPage: 10,
      totalTasks: 0,
      loading: false,
      showReviewColumn: this.$route.query.show_review != null,
      headers: [
        { text: 'Company', value: 'name' },
        { text: 'Created At', value: 'created_at' },
        { text: '', value: 'details' },
      ],
      fetchTimer: null // Store the interval ID
    }
  },
  methods: {
    filter_headers() {
      return this.headers.filter(h => !h.disable)
    },
    scheduleNextFetch(time) {
      this.fetchTimer = setTimeout(async () => {
        await this.fetchCompanyList();
        this.scheduleNextFetch(time); // Schedule the next fetch
      }, time);
    },
    async fetchCompanyList() {
      this.loading = true
      try {
        const response = await this.$http.post('/api/company/list', {
          search: this.search,
          order_by: this.order.order_by,
          order: this.order.value,
          page: this.page,
          per_page: this.perPage
        })
        this.companies = response.data.companies
        this.totalTasks = response.data.total   // Adjust based on actual total
      } catch (error) {
        console.error('Error fetching companies:', error)
      }
      this.loading = false
    },
    // async restartTask(taskId) {
    //   this.loading = true
    //   try {
    //     await this.$http.post(`/api/tasks/${taskId}/restart`)
    //     await this.fetchTasks()
    //     alert('Task restarted successfully')
    //   } catch (error) {
    //     console.error('Error restarting task:', error)
    //     alert('Failed to restart task')
    //   }
    //   this.loading = false
    // },
    updatePage(page) {
      this.page = page
      this.fetchCompanyList()
    },
    formatTime(time) {
      if (!time) return ''
      const date = new Date(time)
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }
      const formatter = new Intl.DateTimeFormat('en-HK', options)
      const parts = formatter.formatToParts(date)
      return `${parts[4].value}-${parts[2].value}-${parts[0].value} ${parts[6].value}:${parts[8].value}:${parts[10].value}`
    },
    formatStatus(status) {
      if (!status) return ''
      return status
        .replace(/_/g, ' ')
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
    goToCompanyDetails(id) {
      this.$router.push({ name: `CompanyDetails`, params: { id } })
    },
  },
  mounted() {
    this.fetchCompanyList() // Initial fetch
    // Set up interval to fetch tasks every 15 seconds
    this.scheduleNextFetch(15000)   // Start the first fetch
  },
  beforeDestroy() {
    // Clear the interval to prevent memory leaks
    if (this.fetchTimer) {
      clearTimeout(this.fetchTimer)
    }
  }
}
</script>
